<template>
  <a-card style="width: 100%">
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="申请">
        <Toapplyfor></Toapplyfor>
      </a-tab-pane>
      <a-tab-pane key="2" tab="立项" force-render>
        <project></project>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import Toapplyfor from './perapp/Toapplyfor.vue'
import project from './perapp/project.vue'
export default {
  components: {
    Toapplyfor,
    project,
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    callback(key) {
      console.log(key)
    },
  },
}
</script>

<style lang="less" scoped>
</style>
